import styles from "./VerticalSeparator.module.scss";

export function VerticalSeparator() {
    return <span className={styles.VerticalSeparator}></span>
}